import {
  Badge,
  Box,
  Card,
  Stack,
  Title,
  UnstyledButton,
  useMantineColorScheme,
} from "@mantine/core";
import { useTranslation } from "react-i18next";

import classes from "../CarCard/CarCard.module.css";
import garageCard from "./GarageCard.module.css";

import { IconSportCar } from "@/components/icons";

import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type GarageCardProps = {
  count?: number;
  name: string;
  onClick?: () => void;
} & MantineStyleProps;

export const GarageCard: FC<GarageCardProps> = ({ count = 0, name, onClick, ...props }) => {
  const { t } = useTranslation();
  const { colorScheme } = useMantineColorScheme();

  const hasBorder = colorScheme === "dark" ? garageCard.cardBorder : "";
  const titleColor = colorScheme === "dark" ? "primary.2" : "primary";

  return (
    <UnstyledButton classNames={classes} onClick={onClick}>
      <Card miw={280} {...props} className={`${garageCard.card} ${hasBorder}`}>
        <Stack gap="sm" p="md">
          <Title order={2} c={titleColor} fz="h3">
            {name}
          </Title>
          <Box ta="right">
            <Badge leftSection={<IconSportCar size={20} />} py={0} variant="light">
              {t("components.GarageCard.cars_count", { count })}
            </Badge>
          </Box>
        </Stack>
      </Card>
    </UnstyledButton>
  );
};
